import { Link } from "react-router-dom";

const social = [
  { href: "https://www.linkedin.com/in/nitinn/", icon: "fa-brands fa-linkedin-in", label: "LinkedIn" },
  { href: "https://x.com/narangnitin", icon: "fa-brands fa-x-twitter", label: "X" },
  { href: "https://www.instagram.com/withnitin/", icon: "fa-brands fa-instagram", label: "Instagram" },
  { href: "https://wa.me/919988884393", icon: "fa-brands fa-whatsapp", label: "WhatsApp" },
];

export default function Footer() {
  return (
    <footer className="section-dark mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-4">Office of the President · AICF</div>
            <h3 className="font-display text-3xl lg:text-4xl mb-4 text-[#faf8f3]">
              Nitin Narang
            </h3>
            <p className="text-[#cfc6b3] text-[15px] leading-relaxed max-w-md">
              President, All India Chess Federation. Founder & CEO of The Ideaz Factory.
              Entrepreneur, investor, and ecosystem builder.
            </p>
            <div className="flex items-center gap-5 mt-8">
              {social.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  aria-label={s.label}
                  className="w-10 h-10 border border-[rgba(255,255,255,0.2)] flex items-center justify-center hover:border-[#b8975d] hover:text-[#b8975d] transition-colors text-[#cfc6b3]">
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow mb-4">Sections</div>
            <ul className="space-y-2.5 text-[14px] text-[#cfc6b3]">
              <li><Link to="/about" className="hover:text-[#b8975d]">Biography</Link></li>
              <li><Link to="/chess-leadership" className="hover:text-[#b8975d]">Chess Leadership</Link></li>
              <li><Link to="/news" className="hover:text-[#b8975d]">Newsroom</Link></li>
              <li><Link to="/videos" className="hover:text-[#b8975d]">Videos</Link></li>
              <li><Link to="/thought-leadership" className="hover:text-[#b8975d]">Thought Leadership</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow mb-4">Resources</div>
            <ul className="space-y-2.5 text-[14px] text-[#cfc6b3]">
              <li><Link to="/companies" className="hover:text-[#b8975d]">Companies</Link></li>
              <li><Link to="/media-kit" className="hover:text-[#b8975d]">Media Kit</Link></li>
              <li><Link to="/gallery" className="hover:text-[#b8975d]">Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-[#b8975d]">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow mb-4">Press</div>
            <ul className="space-y-2.5 text-[14px] text-[#cfc6b3]">
              <li><a href="mailto:nitin@theideazfactory.com" className="hover:text-[#b8975d]">nitin@theideazfactory.com</a></li>
              <li><a href="https://wa.me/919988884393" target="_blank" rel="noreferrer" className="hover:text-[#b8975d]">+91 99888 84393</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[rgba(255,255,255,0.12)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-[#9d9580] tracking-wider">
          <div>© {new Date().getFullYear()} Nitin Narang. All rights reserved.</div>
          <div className="opacity-70">
            The information on this site is curated from public sources. Items marked "publicly listed as" are pending verification.
          </div>
        </div>
      </div>
    </footer>
  );
}
